module.exports = __webpack_public_path__ + "img/QuickProduction_logo_mine4.f24e3fdd.svg";